import axios from '../config/axios';

export async function filtrosCalendario() {
  return await axios.get('/agendamiento/api/v1/filtrosCalendario');
}
export async function consultarEsquemaCreacionHorarios(key) {
  return await axios.get('/horarios_consultas/horarios/api/v3/leer_esquema', {
    params: {
      key,
    },
  });
}
export async function crearHorario(creacion_horario) {
  return await axios.post('/horarios_consultas/horarios/api/v1/crear_horario',

    creacion_horario);
}
export async function eliminarHorario(eliminar_horario) {
  console.log('eliminar_horario', eliminar_horario);
  return await axios.delete('/horarios_consultas/horarios/api/v1/eliminar_horario',
    { data: eliminar_horario });
}
export async function actualizarHorario(info_original, info_nueva) {
  return await axios.post('/horarios_consultas/horarios/api/v1/actualizar_horario',
    {
      info_original,
      info_nueva,
    });
}
export async function actualizarSubhorario(info_original, info_nueva) {
  return await axios.post('/horarios_consultas/horarios/api/v1/actualizar_subhorario',
    {
      info_original,
      info_nueva,
    });
}
export async function consultarAgenda(formulario) {
  return await axios.post('/horarios_consultas/horarios/api/v1/leer_horario',

    formulario);
}
export async function eventosFiltrados(fechaInicial, fechaFinal, filtros) {
  return await axios.post('/agendamiento/api/v1/eventosFiltrados',
    {
      fechaInicial,
      fechaFinal,
      filtros,
    });
}
export async function buscarPorCedula(documento) {
  return await axios.post('/agendamiento/api/v1/consultarEventos',
    {
      documento,
    });
}
export async function cargarDocumentoAsistida(files, formData) {
  console.log('file3:', files);
  return await axios({
    method: 'POST',
    url: '/formularios_cuestionarios/archivos/api/v1/carga_asistida',
    data: formData,
    config: {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
  });
}



// WEBPACK FOOTER //
// ./src/apiService/request/Calendario.js